import { render, staticRenderFns } from "./mapa_regiones.vue?vue&type=template&id=42ccace8&scoped=true"
import script from "./mapa_regiones.vue?vue&type=script&lang=js"
export * from "./mapa_regiones.vue?vue&type=script&lang=js"
import style0 from "./mapa_regiones.vue?vue&type=style&index=0&id=42ccace8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ccace8",
  null
  
)

export default component.exports